/**
 * Страницы вкладки контент-мониторинга после фильтров шапки (владелец / категория / соцсети).
 *
 * Одна функция на вкладку и на кнопку «Экспорт»: отчёт должен собираться ровно по тем
 * страницам, что сейчас на экране. Пустой фильтр (null / []) — ограничения нет.
 */
export function filterCmPages(pages, { owner, category, categories, socials } = {}) {
  let list = pages || [];

  if (owner) {
    list = list.filter((p) => p.email === owner);
  }

  if (category != null) {
    const found = (categories || []).find((c) => c.id === category);
    const ids = found ? (found.pages ? found.pages.map((p) => p.page_id) : found.page_ids || []) : [];
    const set = new Set(ids);
    list = list.filter((p) => set.has(p.page_id));
  }

  if (socials && socials.length) {
    const set = new Set(socials);
    list = list.filter((p) => set.has(String(p.social || "").toUpperCase()));
  }

  return list;
}
